import { render, staticRenderFns } from "./BGMusicSelection.vue?vue&type=template&id=45fd17a8&"
import script from "./BGMusicSelection.vue?vue&type=script&lang=js&"
export * from "./BGMusicSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports